import styled from 'styled-components'

export const Title = styled.div`
  color: ${(props) => props.color};
  font-weight: bold;
  margin-bottom: ${(props) => (props.color === 'black' ? '4px' : '11px')};
  margin-top: ${(props) => (props.color === 'black' ? '20px' : '15px')};
`

export const Body = styled.div`
  margin-bottom: ${(props) => (props.heightBox ? props.heightBox : 'auto')};
  white-space: pre-line;
  text-align: justify;
`
